import React, { useState, useRef, useEffect } from 'react'
import cx from 'classnames'
import { Text } from '@components/UI'

const About = ({ file, showDescription = true }) => {
  const descriptionRef = useRef(null)
  const [hasMoreDescription, setHasMoreDescription] = useState(false)
  const [showMoreDescription, setShowMoreDescription] = useState(false)

  useEffect(() => {
    if (!descriptionRef.current) return
    if (
      descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight
    )
      setHasMoreDescription(true)
  }, [])

  return (
    <div className='gp-preview-header-about'>
      <Text className='semibold text-g gp-preview-header-name'>
        {file.name}
      </Text>
      {!!file.description && showDescription && (
        <div
          className={cx('gp-preview-header-description', {
            'with-more': showMoreDescription
          })}
        >
          <Text
            reference={descriptionRef}
            className='text-d'
            style={{ opacity: 0.85 }}
          >
            {file.description}
          </Text>

          {hasMoreDescription && (
            <button
              className='gp-preview-header-more'
              onClick={() => setShowMoreDescription((showing) => !showing)}
            >
              <Text className='semibold text-a'>
                READ {showMoreDescription ? 'LESS' : 'MORE'}
              </Text>
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default About
